module.exports = __webpack_public_path__ + "img/fig05.28148044.jpg";